module.exports = __webpack_public_path__ + "static/media/404.4792d95c.png";